import Vue from 'vue'

const EditorCardInstance = Vue.extend(require('./editorCard.vue').default);
let instance = null

let getInstance = () => {
  return new EditorCardInstance({
    el: document.createElement('div')
  })
}

let close = () => {
  instance.close()
  instance.$el.parentNode.removeChild(instance.$el);
  instance = null
}

let EditorCard = (id, el, type) => {
  if (instance) {
    close()
  }
  instance = getInstance()

  el.appendChild(instance.$el);
  instance.open(id, type)
}


export default EditorCard
